/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-restricted-globals */
import React, { FC, useCallback, useState } from 'react';
import { useEvent } from 'react-use';
import { CookieContext } from './CookieContext';
import { getCookieConsent } from './cookie.utils';
import { CookieCategories } from './cookies.types';

function updateGoogleAnalytics(gtag: string, categories: CookieCategories[]) {
  if (!gtag) {
    // Nothing to do
    return;
  }

  if (typeof window === 'undefined' || !(window as any).gtag) {
    // Missing gtag context ?
    return;
  }

  const hasGoogleAnalytics = categories.includes(CookieCategories.GOOGLE_ANALYTICS);
  if (hasGoogleAnalytics) {
    (window as any).gtag('consent', 'update', {
      analytics_storage: 'granted',
    });
    (window as any).gtag('config', gtag);
  } else {
    // disable gtag
    (window as any).gtag('consent', 'update', {
      analytics_storage: 'denied',
    });
  }
}

// eslint-disable-next-line react/no-unused-prop-types
const CookieContextProvider: FC<{ lang: string; eventId: string; children: any }> = ({
  eventId,
  children,
}) => {
  // eslint-disable-next-line no-restricted-globals
  const { cookieBanner } = window.__DATA__;
  const [, setState] = useState(0);
  const refreshCookies = useCallback(() => setState(Date.now()), [setState]);
  useEvent('cc:onConsent', refreshCookies);
  useEvent('cc:onChange', refreshCookies);

  const { categories } = getCookieConsent(eventId);

  updateGoogleAnalytics(cookieBanner?.gtag, categories);

  return (
    <CookieContext.Provider value={{ hasCookieBanner: !!cookieBanner?.enabled, categories }}>
      {children}
    </CookieContext.Provider>
  );
};

export default CookieContextProvider;
